<template>
  <div class="head-container">
    <div class="img-container">
      <img src="../assets/logo.png" alt="">
    </div>
    <div tab-container>
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="1">首页</el-menu-item>
        <el-menu-item index="2">智慧课堂</el-menu-item>
        <el-menu-item index="3">服务支持</el-menu-item>
        <el-menu-item index="4">关于我们</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Mheader',
    data () {
      return {
        activeIndex:'1'
      }
    },
    methods:{
      handleSelect(index){
        this.$emit('changeTab',index)
      }
    }
  }
</script>

<style scoped lang="less">
.head-container{
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: space-around;
}
.img-container{
  width: 174px;
  height: 40px;
  /* margin-left: 347px;
  margin-right: 717px; */
}
.img-container img{
  width: 100%;
  height: 100%;
}
/deep/.el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 3px solid #409EFF;
    color: #409EFF;
    font-weight:bold;
}
/deep/.el-menu-item{
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue